var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pagination.totalPages > 1
    ? _c(
        "nav",
        {
          staticClass: "pagination",
          attrs: { role: "navigation", "aria-label": "pagination" }
        },
        [
          _c("ul", { staticClass: "pagination-list" }, [
            _c("li", { staticClass: "pagination-prev" }, [
              _c(
                "button",
                {
                  staticClass: "pagination-previous",
                  attrs: {
                    disabled: _vm.pagination.pageIndex <= 1 ? "disabled" : false
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.changePage(_vm.pagination.pageIndex - 1)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "sr-only" }, [_vm._v("previous")]),
                  _c("i", { staticClass: "fas fa-chevron-left" })
                ]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "pagination-page" }, [
              _c(
                "button",
                {
                  staticClass: "pagination-dropdown-label",
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.togglePaginationDropdown($event)
                    },
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.togglePaginationDropdown($event)
                    }
                  }
                },
                [
                  _vm._v("Showing "),
                  _c("span", { staticClass: "pagination-dropdown-pages" }, [
                    _vm._v(
                      _vm._s(_vm.pagination.pageIndex) +
                        " of " +
                        _vm._s(_vm.pages.length)
                    )
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "fas fa-chevron-down" })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pagination-dropdown" }, [
                _c(
                  "ul",
                  { attrs: { id: "simplebar" } },
                  _vm._l(_vm.pages, function(page) {
                    return _c(
                      "li",
                      {
                        staticClass: "pagination-dropdown-item",
                        class: _vm.isCurrentPage(page) ? "active" : "",
                        attrs: { tabindex: "0", "data-page": page },
                        on: {
                          click: function($event) {
                            return _vm.changePage(page)
                          },
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.changePage(page)
                          }
                        }
                      },
                      [_vm._v("Page " + _vm._s(page))]
                    )
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "pagination-next" }, [
              _c(
                "button",
                {
                  staticClass: "pagination-next",
                  attrs: {
                    disabled:
                      _vm.pagination.pageIndex >= _vm.pagination.totalPages
                        ? "disabled"
                        : false
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.changePage(_vm.pagination.pageIndex + 1)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "sr-only" }, [_vm._v("next")]),
                  _c("i", { staticClass: "fas fa-chevron-right" })
                ]
              )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }